import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Dash, Plus } from "react-bootstrap-icons";

export default function CreateClassModal({ cancelModal, fetchData, pendingclub }) {
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [day, setDay] = useState("Monday");
  const [timeIn, setTimeIn] = useState("");
  const [timeInErr, setTimeInErr] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [timeOutErr, setTimeOutErr] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const [price, setPrice] = useState(null);
  const [priceErr, setPriceErr] = useState("");
  const [additionalDays, setAdditionalDays] = useState([]);
  const [addAdditionalDays, setAddAdditionalDays] = useState(false);
  const [additionalDay, setAdditionalDay] = useState("Monday");
  const [additionaltimeIn, setAdditionalTimeIn] = useState("");
  const [additionaltimeInErr, setAdditionalTimeInErr] = useState("");
  const [additionaltimeOut, setAdditionalTimeOut] = useState("");
  const [additionaltimeOutErr, setAdditionalTimeOutErr] = useState("");
  const [bookingCapacity, setBookingCapacity] = useState(0);

  // styled
  const handlePriceChange = (e) => {
    const value = e.target.value ? parseFloat(e.target.value) : null;
    setPrice(value);
  };

  const nameRegex = /^[a-zA-Z0-9 ]+$/;

  const convertTimeToInt = (time) => {
    return parseInt(time.replace(":", ""), 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNameErr("");
    setDescriptionErr("");
    setTimeInErr("");
    setTimeOutErr("");
    let error = false;
    //Name Validations
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    if (!nameRegex.test(name)) {
      error = true;
      setNameErr("The Name can only include letters, spaces");
    }
    //Description Validations
    if (name.description > 3000) {
      error = true;
      setDescriptionErr("Name is too long");
    }
    //TimeIn Validation
    if (timeIn > timeOut) {
      error = true;
      setTimeInErr("Time in must not be greater than the time out");
    }

    //Price Validation
if (price > 50) {
  error = true;
  setPriceErr(`The price must not exceed ${pendingclub.country === "UK" ? "£" : "$"}50`);
} else if (price > 0 && price < 1) {
  error = true;
  setPriceErr(`The price must be at least ${pendingclub.country === "UK" ? "£" : "$"}1`);
}

    if (!error) {
      try {
        setIsLoading(true);
        const createPendingEvent = {
          name,
          description,
          day,
          timeIn: convertTimeToInt(timeIn),
          timeOut: convertTimeToInt(timeOut),
          price: price * 100,
          additionalDays,
          bookingCapacity,
        };

        const createResponse = await axios.post(
          `${ApiConnectionString}/api/pendingEvent`,
          createPendingEvent,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (createResponse.status == 200) {
          //  fetchData();
          setComplete(true);
        }
      } catch (error) {
        console.error("Error creating pending event:", error);
        // Handle the error (e.g., display an error message to the user)
      } finally {
        setIsLoading(false); // Ensure that loading is stopped regardless of success or failure
      }
    }
  };

  const AddAdditioalDayFunk = () => {
    let error = false;
    setAdditionalTimeInErr("");
    setAdditionalTimeOutErr("");
    if (additionaltimeIn > additionaltimeOut) {
      error = true;
      setAdditionalTimeOutErr("Time in must not be greater than the time out");
    }
    if (additionaltimeIn.length == 0 || additionaltimeOut.length == 0) {
      error = true;
    }

    if (!error) {
      const newDay = {
        day: additionalDay,
        timeIn: convertTimeToInt(additionaltimeIn),
        timeOut: convertTimeToInt(additionaltimeOut),
      };

      setAdditionalDays([...additionalDays, newDay]);

      // Optionally reset the input fields after adding
      setAdditionalDay("Monday");
      setAdditionalTimeIn("");
      setAdditionalTimeOut("");
    }
  };
  const removeDay = (indexToRemove) => {
    setAdditionalDays(
      additionalDays.filter((_, index) => index !== indexToRemove)
    );
  };

  if (isLoading) {
    return (
      <div className="fullscreen-modal-overlay">
        <div className="fullscreen-modal">
          <LoadingSpinner />

          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="fullscreen-modal-overlay">
          <div className="fullscreen-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Class(s) Created</p>
            </div>
            <p>
              Class(s) successfully created and added to the club timetable.
            </p>

            <button
              type="button"
              className="close-button"
              onClick={() => {
                fetchData();
                cancelModal();
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="send-modal-footer">
              <button
                onClick={() => {
                  fetchData();
                  cancelModal();
                }}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="fullscreen-modal-overlay">
          <div className="fullscreen-modal">
            <div className="blueBanner d-flex justify-content-between">
              <p className="fw-bold m-2 p-2 fontSize20">Create Class</p>
              <button
                onClick={() => cancelModal()}
                className="saveChanges-button"
              >
                Go Back
              </button>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <div>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="name">Class Name:</label>
                      </td>
                      <td>
                        <input
                          type="text"
                          id="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                        {nameErr && <p className="text-danger">{nameErr}</p>}
                      </td>
                    </tr>
                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="description">Subtitle:</label>
                      </td>
                      <td>
                        <textarea
                          id="description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                        {descriptionErr && (
                          <p className="text-danger">{descriptionErr}</p>
                        )}
                        <p className="text-muted">
                          For example, "All levels and abilities"
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="timeIn">Time In:</label>
                      </td>
                      <td>
                        <input
                          type="time"
                          id="timeIn"
                          value={timeIn}
                          onChange={(e) => setTimeIn(e.target.value)}
                          required
                        />
                        {timeInErr && (
                          <p className="text-danger">{timeInErr}</p>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="timeOut">Time Out:</label>
                      </td>
                      <td>
                        <input
                          type="time"
                          id="timeOut"
                          value={timeOut}
                          onChange={(e) => setTimeOut(e.target.value)}
                          required
                        />
                        {timeOutErr && (
                          <p className="text-danger">{timeOutErr}</p>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="day">Day:</label>
                      </td>
                      <td>
                        <select
                          id="day"
                          value={day}
                          onChange={(e) => setDay(e.target.value)}
                          required
                        >
                          <option value="Monday">Monday</option>
                          <option value="Tuesday">Tuesday</option>
                          <option value="Wednesday">Wednesday</option>
                          <option value="Thursday">Thursday</option>
                          <option value="Friday">Friday</option>
                          <option value="Saturday">Saturday</option>
                          <option value="Sunday">Sunday</option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="price">Class Capacity: </label>
                      </td>
                      <td>
                        <input
                          type="number"
                          id="classLimit"
                          name="classLimit"
                          pattern="^\d*$"
                          inputMode="numeric"
                          value={bookingCapacity}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Optionally validate the value or ignore invalid input
                            if (/^\d*$/.test(value)) {
                              setBookingCapacity(value);
                            }
                          }}
                        />
                        <p className="text-muted">
                          How many people can attend this at one time? If there
                          is no limit, leave it as zero.
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td className="red-text fw-bold">
                   <label htmlFor="price">
  Price ({pendingclub.country === "UK" ? "£" : "$"}):
</label>
                      </td>
                      <td>
                        <input
                          className=""
                          type="number"
                          id="price"
                          step="0.01"
                          value={price === null ? "" : price}
                          onChange={handlePriceChange}
                          placeholder="Enter price"
                        />
                      </td>
                    </tr>
                  </tbody>
                  {priceErr && <p className="text-danger">{priceErr}</p>}
                </table>
                <p className="text-muted">
                  The price is the cost for a customer to book this class as a
                  one-time purchase, without a subscription or class tokens. If
                  you do not want to offer this option, leave this field blank.
                </p>

                <hr></hr>

                {/* start  */}

                <div>
                  {additionalDays.length > 0 && (
                    <div className="additional-classes-section mt-4">
                      <h5 className="section-heading mb-3">
                        Additional Classes
                      </h5>
                      {additionalDays.map((day, index) => (
                        <div
                          key={index}
                          className="additional-class-card d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-2"
                        >
                          <div>
                            <div>
                              <strong>Day:</strong> {day.day}
                            </div>
                            <div>
                              <strong>Time In:</strong> {day.timeIn}
                            </div>
                            <div>
                              <strong>Time Out:</strong> {day.timeOut}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => removeDay(index)}
                            className="profile-blue-button d-flex align-items-center"
                          >
                            <Dash className="profile-social-icon" />
                            <span className="fw-bold text-white mx-2">
                              Remove
                            </span>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {addAdditionalDays && (
                    <div className="border">
                      <div>
                        <label htmlFor="timeIn">Time In:</label>
                        <input
                          type="time"
                          id="timeIn"
                          value={additionaltimeIn}
                          onChange={(e) => setAdditionalTimeIn(e.target.value)}
                        />
                        {timeInErr && (
                          <p className="text-danger">{additionaltimeInErr}</p>
                        )}
                      </div>
                      <div>
                        <label htmlFor="timeOut">Time Out:</label>
                        <input
                          type="time"
                          id="timeOut"
                          value={additionaltimeOut}
                          onChange={(e) => setAdditionalTimeOut(e.target.value)}
                        />
                        {additionaltimeOutErr && (
                          <p className="text-danger">{additionaltimeOutErr}</p>
                        )}
                      </div>
                      <label htmlFor="day">Day:</label>
                      <select
                        id="day"
                        value={additionalDay}
                        onChange={(e) => setAdditionalDay(e.target.value)}
                      >
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <option value="Sunday">Sunday</option>
                      </select>

                      <div className="d-flex justify-content-between">
                        <button
                          onClick={AddAdditioalDayFunk}
                          className="profile-blue-button mb-2 d-flex"
                        >
                          <Plus className="profile-social-icon" />{" "}
                          <a className="fw-bold mx-2 mt-1">Add day</a>
                        </button>

                        <button
                          className="pointer cancelButton fw-bold mx-2 px-3"
                          onClick={(e) => {
                            e.preventDefault();
                            setAddAdditionalDays(false);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}
                  {!addAdditionalDays && (
                    <p>
                      If you want to duplicate this class on additional days and
                      times, please press "Add an Additional Class" below.
                    </p>
                  )}
                  {!addAdditionalDays && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setAddAdditionalDays(true);
                      }}
                      className="profile-blue-button mb-2 d-flex"
                    >
                      <Plus className="profile-social-icon" />{" "}
                      <a className="fw-bold mx-2 mt-1">
                        Add An Additional Class
                      </a>
                    </button>
                  )}
                </div>

                {/* fin  */}

                <button
                  onClick={handleSubmit}
                  className="saveChanges-button mt-5 fw-bold"
                >
                  Create Class(s)
                </button>
              </div>
            </div>
            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
